<template>
  <div class="my-customer-order">
    <div>我的订单</div>
    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="所有订单" name></el-tab-pane>
        <el-tab-pane label="待确认" name="1"></el-tab-pane>
        <el-tab-pane label="待发货" name="4"></el-tab-pane>
        <el-tab-pane label="待收货" name="5"></el-tab-pane>
        <el-tab-pane label="已完成" name="6"></el-tab-pane>
        <el-tab-pane label="售后" name="9999"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div>
        <el-input
            style="width: 336px"
            placeholder="请输入订单号搜索"
            v-model="order_no"
            size="mini"
        ></el-input>

        <el-button class="ml20" type="primary" size="mini" @click="getOrderList">搜索</el-button>
      </div>
    </div>

    <!--订单列表-->
    <!--表头-->

    <div class="fr ac fz12 mt30">
      <div class="center order-list-item">产品信息</div>
      <div class="center order-list-item">产品规格</div>
      <div class="center order-list-item">设备信息</div>
      <!-- <div class="center order-list-item">配套工艺</div> -->
      <div class="center order-list-item">产品价格</div>
      <div class="center order-list-item">数量</div>
      <div class="center order-list-item">小计</div>
      <div class="center fg">操作</div>
    </div>

    <el-divider/>

    <!--列表-->
    <!-- 普通订单列表 -->
    <div class="order-list fz12" v-if="tab != '9999'">
      <div class="order-item mt20" v-for="(item, index) in order_list" :key="index">
        <!-- 上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span
              class="ml40 blue"
              v-if="tab != '9999'"
              v-html="order_state_decide(item)"
          ></span>
          <span class="ml40 blue" v-else>{{
              item.is_reply == "1" ? "已回复" : "未回复"
            }}</span>
        </div>
        <!-- 中-->

        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div
                class="fr jc ac order_left"
                v-for="(goods, i) in item.orderGoodsBeans"
                :key="i"
            >
              <div class="fr pl10 pr20 pt20 pb20 order-list-item">
                <el-image
                    class="goods_img fs mr10"
                    :src="goods.goods_img"
                    alt
                />
                <div class="fc jsb">
                  <p class>
                    {{ goods.goods_name }} {{ goods.goods_standard_name }}
                  </p>
                  <p
                      class="blue cursor"
                      v-if="goods.goods_type == 1"
                      @click="showCaraft(goods)"
                  >
                    工艺详情
                  </p>
                </div>
              </div>
              <div class="center order-list-item"> {{ specNameInit(goods) }}</div>
              <div class="center order-list-item">
                {{ goods.device_id ? goods.device_id : "-" }}
              </div>

              <!-- <div class="center order-list-item bule">
                                {{goods.goods_type==1?
                                "￥"+goods.goods_craft_price:'-'}}
              </div>-->
              <div class="center order-list-item">
                {{ item.price_show ? "￥" + goods.goods_price : "-" }}
              </div>
              <div class="center order-list-item">{{ goods.goods_num }}</div>
              <div class="center order-list-item red">
                {{ item.price_show ? "￥" + goods.goods_total_price : "-" }}
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="fc jc ac fg fs operating">
            <template v-if="tab != '999'">
              <!-- 待审核订单,销售未审核时的取消订单 -->
              <template v-if="item.company_check_state === '1' && item.platform_sale_check_state === '0'">
                <p class="grey text-button" @click="cancelOrder(item.order_id)"> 取消订单 </p>
              </template>
              <template v-if="false">
                <p class="text-button"
                   @click="go(`/myCustomer/orderdetail?id=${item.order_id}&company_id=${item.company_id}`)">
                  确认订单 </p>
                <p class=" grey text-button" @click="companyCancel2Order(item.order_id)"> 取消订单 </p>
              </template>
              <p
                  class="grey text-button"
                  v-if="item.send_state === '2' || item.send_state === '3'"
                  @click="go(`/logistics?id=${item.order_id}&company_id=${item.company_id}`)">查看物流</p>
              <p class="grey text-button" v-if="item.send_state !== '1'" @click="feddback(item)">
                质量反馈
              </p>
              <p v-if="item.contract_check_state === '1'" class="text-button" @click="repurchaseOrder(item.order_id)">
                复购
              </p>
              <template v-if="item.pay_state === '3' && item.send_state === '4'">
                <p class="text-button" @click="getAssessmentGoods(item)">
                  立即评价
                </p>

                <p
                    class="text-button"
                    @click="go(`/releaseservice?id=${item.order_id}`)"
                    v-if="item.is_service !== '1'"
                >
                  申请服务
                </p>
              </template>

              <!-- 待发货订单 -->
              <p
                  v-if="tab !== '9999'"
                  class="text-button grey"
                  @click="go(`/myCustomer/orderdetail?id=${item.order_id}&company_id=${item.company_id}`)">
                订单详情
              </p>
            </template>

            <!-- 质量反馈 -->
            <template v-if="tab === '9999'">
              <p
                  class="text-button grey"
                  @click="go(`/feedbackdetail?id=${item.order_id}`)"
              >
                订单详情
              </p>
            </template>
          </div>
        </div>

        <!-- 下-->
        <div
            class="p20 fz14 bottom black"
            style="text-align: right"
            v-if="item.price_show"
        >
          <div>
            <span>订单金额</span>
            <span class="blue">￥{{ item.order_actual_price }}</span>
          </div>
          <div class="mt10">
            <span>已付款</span>
            <span>￥{{ item.pay_price }}</span>
          </div>
          <div class="mt10">
            <span>未付款</span>
            <span class="red">￥{{ sub(item.order_actual_price, item.pay_price) }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 服务订单列表 -->
    <div class="order-list fz12" v-if="tab === '9999'">
      <div
          class="order-item mt20"
          v-for="(item, index) in order_list"
          :key="index"
      >
        <!-- 上-->
        <div class="top">
          <span>{{ item.create_time }}</span>
          <span class="ml20 grey">订单编号：{{ item.order_no }}</span>
          <span class="ml40 blue" v-if="tab !== '9999'">{{ item.order_state_show }}</span>
          <span class="ml40 blue" v-else>{{ item.is_reply === "1" ? "已回复" : "未回复" }}</span>
        </div>
        <!-- 中-->

        <div class="fr middle">
          <!-- 商品信息 -->
          <div class="order">
            <div class="fr jc ac order_left">
              <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                <el-image
                    class="goods_img fs mr10"
                    :src="item.orderGoodsBean.goods_img"
                    alt
                />
                <p class>
                  {{ item.orderGoodsBean.goods_name }}
                  {{ item.irderGoodsBean.goods_standard_name }}
                </p>
              </div>
              <div class="center order_list_item"> {{ specNameInit(item.orderGoodsBean) }}</div>

              <div class="center order-list-item">
                {{ item.orderGoodsBean.device_id ? item.orderGoodsBean.device_id : "-" }}
              </div>
              <div class="center order-list-item"> {{ item.price_show ? "￥" + item.orderGoodsBean.goods_price : "-" }}
              </div>
              <div class="center order-list-item"> {{ item.orderGoodsBean.goods_num }}</div>
              <div class="center order-list-item red">
                {{ item.price_show ? "￥" + item.orderGoodsBean.goods_total_price : "-" }}
              </div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="fc jc ac fg fs operating">
            <!-- 质量反馈 -->
            <template v-if="tab === '9999'">
              <p
                  class="mt10 cursor grey"
                  @click="go(`/feedbackdetail?id=${item.order_id}`)"
              >
                订单详情
              </p>
            </template>
          </div>
        </div>

        <!-- 下-->
        <div
            class="p20 fz14 bottom black"
            style="text-align: right"
            v-if="item.price_show"
        >
          <div>
            <span>订单金额</span>
            <span class="blue">￥{{ item.order_actual_price }}</span>
          </div>
          <div class="mt10">
            <span>已付款</span>
            <span>￥{{ item.pay_price }}</span>
          </div>
          <div class="mt10">
            <span>未付款</span>
            <span class="red">￥{{ sub(item.order_actual_price, item.pay_price) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="fr jc ac mt30 mb30">
      <el-pagination
          background
          :hide-on-single-page="true"
          :current-page.sync="page"
          layout="prev, pager, next"
          :total="total"
      ></el-pagination>
    </div>
    <!-- 选择商品评价 -->
    <re-dialog :visible.sync="dialogVisible" width="900px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择评价商品</p>
        <i class="el-icon-close fz14 cursor" @click="dialogVisible = false"></i>
      </div>
      <div class="order-list">
        <div class="order-item mt20">
          <!-- 上-->
          <div class="top">
            <span>{{ assessment_list.create_time }}</span>
            <span class="ml20 grey">订单编号：{{ assessment_list.order_no }}</span>
            <span
                class="ml40 blue"
                v-html="order_state_decide(assessment_list)"
            ></span>
          </div>
          <!-- 中-->
          <div class="middle">
            <!-- 商品信息 -->
            <div
                v-for="(goods, i) in assessment_list.orderGoodsBeans"
                :key="i"
                class="fr"
            >
              <div class="fs fr ac jc radio">
                <el-radio v-model="radio" :label="goods.order_goods_id"
                >&nbsp;
                </el-radio>
              </div>
              <div class="order fr fs">
                <div class="fr jc ac order_left">
                  <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                    <el-image
                        class="goods_img fs mr10"
                        :src="goods.goods_img"
                        alt
                    />
                    <p class>
                      {{ goods.goods_name }} {{ goods.goods_standard_name }}
                    </p>
                  </div>
                  <div class="center order-list-item fz12"> {{ specNameInit(goods) }}</div>
                  <div class="center order-list-item">
                    {{ goods.device_id ? goods.device_id : "-" }}
                  </div>
                  <div class="center order-list-item"> ￥{{ goods.goods_price }}</div>
                  <div class="center order-list-item"> {{ goods.goods_num }}</div>
                  <div class="center order-list-item red"> ￥{{ goods.goods_total_price }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="fr ac jc">
        <el-button type="primary" @click="Evaluation">立即评价</el-button>
      </span>
    </re-dialog>
    <!-- 选择商品质量反馈 -->
    <re-dialog :visible.sync="feekdialogVisible" width="900px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">质量反馈</p>
        <i
            class="el-icon-close fz14 cursor"
            @click="feekdialogVisible = false"
        ></i>
      </div>
      <div class="order-list">
        <div class="order-item mt20">
          <!-- 上-->
          <div class="top">
            <span>{{ feed_list.create_time }}</span>
            <span class="ml20 grey">订单编号：{{ feed_list.order_no }}</span>
            <span
                class="ml40 blue"
                v-html="order_state_decide(feed_list)"
            ></span>
          </div>
          <!-- 中-->
          <div class="middle">
            <!-- 商品信息 -->
            <div
                v-for="(goods, i) in feed_list.orderGoodsBeans"
                :key="i"
                class="fr"
            >
              <div class="fs fr ac jc radio">
                <el-radio v-model="feekradio" :label="goods.order_goods_id">&nbsp;</el-radio>
              </div>
              <div class="order fr fs">
                <div class="fr jc ac order_left">
                  <div class="fr afs pl10 pr20 pt20 pb20 order-list-item">
                    <el-image
                        class="goods_img fs mr10"
                        :src="goods.goods_img"
                        alt
                    />
                    <p class>
                      {{ goods.goods_name }} {{ goods.goods_standard_name }}
                    </p>
                  </div>
                  <div class="center order-list-item fz12"> {{ specNameInit(goods) }}</div>
                  <div class="center order-list-item">
                    {{ goods.device_id ? goods.device_id : "-" }}
                  </div>
                  <div class="center order-list-item">
                    ￥{{ goods.goods_price }}
                  </div>
                  <div class="center order-list-item">
                    {{ goods.goods_num }}
                  </div>
                  <div class="center order-list-item red">
                    ￥{{ goods.goods_total_price }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="fr ac jc">
        <el-button type="primary" @click="selectFeedback">立即反馈</el-button>
      </span>
    </re-dialog>
    <!-- 选择配套工艺 -->
    <select-craft
        :show.sync="crafts_show"
        :select_craft_list.sync="goods_crafts"
        :craft_remark.sync="craft_remark"
        :disabled="disabled"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
      disabled: true,
      tab: "",
      order_list: [],
      page: 1,
      total: 0,
      dialogVisible: false,
      feekdialogVisible: false,
      radio: "",
      feekradio: "",
      order_no: "",
      assessment_list: {},
      feed_list: {},
      crafts_show: false,
      goods_crafts: [],
      craft_remark: "",
    };
  },
  watch: {
    page(n) {
      if (this.tab != "9999") {
        this.getOrderList();
      } else {
        this.getFeedbackOrders();
      }
    },
    tab(n) {
      this.page = 1;
      if (n != "9999") {
        this.getOrderList();
      } else {
        this.getFeedbackOrders();
      }
    },
    order_list(n) {
      if (this.tab != "9999") {
        n.forEach((el) => {
          el.price_show = el.platform_sale_check_state == "1" && el.contract_check_state == "1";
          let order_actual_price = el.order_actual_price; //商品修改后价格
          // 每个商品
          if (!this.is_Empty(el.orderGoodsBeans)) {
            el.orderGoodsBeans.forEach((e) => {
              let arr = [];
              e.orderGoodsSpecificationInputBeans.forEach(el => {
                arr.push(el.input_value);
              })
              let count = 1;
              if (arr.length === 2) {
                arr.forEach(el => {
                  count = this.mul(el, count)
                })
              }
              let sum = this.mul(count, e.goods_num);
              e.goods_price = this.toDecimal2(this.div(e.goods_actual_price, sum));
            });
          }
        });
      }
    },
    $route(n) {
      let param = this.$route.query;
      if (param.type) {
        this.tab = param.type;
      }
      if (!this.is_Empty(param.company_id)) {
        this.$store.commit('setCompanyId', param.company_id)
      }
      if (this.tab != "9999") {
        this.getOrderList();
      } else {
        this.getFeedbackOrders();
      }
    },
  },
  deactivated() {
    this.$store.commit('setCompanyId', '')
  },
  created() {
    let param = this.$route.query;
    if (!this.is_Empty(param.company_id)) {
      this.$store.commit('setCompanyId', param.company_id)
    }
    if (param.type) {
      this.tab = param.type;
    }

    if (this.tab != "9999") {
      this.getOrderList();
    } else {
      this.getFeedbackOrders();
    }
  },
  methods: {
    showCaraft(goods) {
      this.goods_crafts = goods.orderCraftBeans;
      this.craft_remark = goods.craft_remark;
      this.crafts_show = true;
    },
    feddback(item) {
      if (item.orderGoodsBeans.length == 1) {
        this.go(
            `/feedback?id=${item.order_id}&goods_id=${item.orderGoodsBeans[0].order_goods_id}`
        );
      } else {
        this.feed_list = item;
        this.feekdialogVisible = true;
      }
    },
    // 反馈商品
    selectFeedback() {
      if (!this.feekradio) {
        this.$message({
          type: "warning",
          message: "未选择要反馈的商品",
        });
        return;
      }
      this.feekdialogVisible = false;
      this.go(
          `/feedback?id=${this.feed_list.order_id}&goods_id=${this.feekradio}`
      );
      this.feed_list = [];
    },
    // /评价商品
    Evaluation() {
      if (!this.radio) {
        this.$message({
          type: "warning",
          message: "未选择要评价的商品",
        });
        return;
      }
      this.dialogVisible = false;
      this.go(
          `/orderevaluation?id=${this.assessment_list.order_id}&goods_id=${this.radio}`
      );
      this.assessment_list = [];
    },
    // 取消订单
    cancelOrder(id) {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.post("orderInterfaces/v1.0/cancelOrder", {
              order_id: id,
            }).then((res) => {
              this.$message({
                type: "success",
                message: "已取消!",
              });
              this.getOrderList();
            });
          })
          .catch(() => {
          });
    },
    //用户二次确认 取消订单
    companyCancel2Order(id) {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.post("orderInterfaces/v1.0/companyCancel2Order", {
              order_id: id,
            }).then((res) => {
              this.$message({
                type: "success",
                message: "已取消!",
              });
              this.getOrderList();
            });
          })
          .catch(() => {
          });
    },
    getAssessmentGoods(item) {
      if (item.orderGoodsBeans.length == 1) {
        this.go(
            `/orderevaluation?id=${item.order_id}&goods_id=${item.orderGoodsBeans[0].order_goods_id}`
        );
      } else {
        this.assessment_list = item;
        this.dialogVisible = true;
      }
    },
    // 复购
    repurchaseOrder(id) {
      this.post("orderInterfaces/v1.0/repurchaseOrder", {
        order_id: id,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "复购成功,已添加到客户购物车!",
        });
        // setTimeout(() => {
        //   this.go("/home/shopcart");
        // }, 1000);
      });
    },
    //获取订单列表
    getOrderList() {
      let param = {
        page: this.page,
        company_id: this.$route.query.company_id,
      };
      if (this.order_no) {
        this.tab = "";
        param.order_no = this.order_no;
      }
      param.company_check_state = "1";
      param.platform_sale_check_state = "";
      param.contract_check_state = "";
      param.pay_state = "";
      param.send_state = "";
      // 待确定订单
      if (this.tab == "1") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "0,1";
        param.contract_check_state = "0";
        param.pay_state = "";
        param.send_state = "";
        // 全部订单
      } else if (this.tab == "0") {
        param.company_check_state = "";
        param.platform_sale_check_state = "";
        param.pay_state = "";
        param.send_state = "";
        // 待发货
      } else if (this.tab == "4") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.contract_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "1";
        // 待收货
      } else if (this.tab == "5") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.contract_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "2,3";
        // 已完成
      } else if (this.tab == "6") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.contract_check_state = "1";
        param.pay_state = "1,2,3";
        param.send_state = "4";
      } else if (this.tab == "7") {
        param.company_check_state = "1";
        param.platform_sale_check_state = "1";
        param.contract_check_state = "1";
      } else {
        param.order_state = this.tab;
      }
      this.post("orderInterfaces/v1.0/getOrders", param).then((res) => {
        this.order_list = res.data;
        this.total = res.total;
      });
    },
    // 获取反馈订单。
    getFeedbackOrders() {
      this.post("orderInterfaces/v1.0/getFeedbackOrders", {
        page: this.page,
        company_id: this.$route.query.company_id,
      }).then((res) => {
        this.order_list = res.data;
        this.total = res.total;
      });
    },
  },
};
</script>

<style lang="scss">
.my-customer-order {
  .text-button {
    margin-top: 10px;
    color: #458EF6;
    cursor: pointer;
    user-select: none;
    -webkit-user-select: none;
  }

  .order-list-item {
    &:nth-of-type(1) {
      width: 270px;
    }

    &:nth-of-type(2) {
      width: 100px;
    }

    &:nth-of-type(3) {
      width: 130px;
    }

    &:nth-of-type(4) {
      width: 100px;
    }

    &:nth-of-type(5) {
      width: 100px;
    }

    &:nth-of-type(6) {
      width: 100px;
    }
  }

  .order-list {
    .order-item {
      border: 1px solid #e5e5e5;

      .top {
        background-color: #f0f6ff;
        padding: 14px;
      }

      .middle {
        border-bottom: 1px solid #e5e5e5;

        .order {
          .order_left {
            border-right: 1px solid #e5e5e5;
            border-bottom: 1px solid #e5e5e5;

            &:last-child {
              border-bottom: none;
            }

            .goods_img {
              width: 80px;
              height: 80px;
            }
          }

          .operating {
            p {
              margin-top: 10px;

              &:nth-of-type(1) {
                margin-top: 0;
              }
            }
          }
        }
      }
    }
  }

  .el-dialog {
    .order_left {
      border-right: none !important;
    }

    .radio {
      width: 60px;
      padding-left: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myCustomerOrder/index.vue